<template>
    <div class="px-3">
        <div class="flex justify-end mb-4">
            <select v-model="$i18n.locale" class="border rounded p-2 text-sm">
                <option value="it">🇮🇹 Italiano</option>
                <option value="en">🇬🇧 English</option>
            </select>
        </div>

        <div v-if="showDownloadScreen" class="container-xl bg-ombra-rounded margine-grande p-5 text-center">
            <h1 class="download-title">{{$t('Scarica l\'App MiCuroBene')}}</h1>
            <p>{{$t('Scegli la piattaforma per scaricare l\'app:')}}</p>
            <div class="platform-buttons">
                <button @click="redirectToAndroid" class="btn platform-btn">{{$t('Scarica per Android')}}</button>
                <button @click="redirectToIOS" class="btn platform-btn">{{$t('Scarica per iOS')}}</button>
            </div>
        </div>

        <div v-else style="user-select: none">
            <div class="container-xl bg-ombra-rounded margine-grande p-5">
                <div class="row mx-5">
                    <div class="col-xl-12 order-2 order-xl-1">
                        <h1 class="w-xl-75 w-100 text-center mx-auto h1-no-home container__title">{{$t('Accedi')}}</h1>
                    </div>
                </div>

                <div class="container-xl margine margine-basso px-5" id="contattaci">
                    <form method="POST" @submit.prevent="loginUser" class="w-100 mx-auto w-md-75">
                        <div class="form-group text-left">
                            <label for="email">Email</label>
                            <input type="email" v-model="email" name="email"
                                class="form-control @error('email') is-invalid @enderror input" id="email" placeholder="Email"
                                required autocomplete="email" autofocus>
                        </div>

                        <div class="form-group text-left">
                            <label for="password">Password</label>
                            <input id="password" v-model="password" type="password" placeholder="Password"
                                class="form-control @error('password') is-invalid @enderror input" name="password" required
                                autocomplete="current-password">
                        </div>

                        <div class="field-group">
                            <a href="/password/reset" class="password">{{ $t('Password dimenticata?') }}</a>

                            <div class="text-center" style="display:flex; justify-content:center;">
                                <p v-if="wrongCredentials != ''" style="font-size: 16px; color:red;">
                                    {{ wrongCredentials == 'login' ? $t('Wrong username or password') : $t('Not registered with Google yet')}}</p>

                                <button type="submit" class="btn bottone-blu grande mt-5" id="submit">
                                    {{$t('Accedi')}}
                                </button>
                                
                            </div>
                            <div class="text-center" style="display:flex; justify-content:center;">
                                <button class="google-login-button" @click="googleLogin">
                                    <img src="../assets/images/google-icon.png" style="height: 1.2rem;">
                                    <p style="margin-left: 0.5rem;"> {{ $t("googleLogin") }}</p>
                                </button>
                            </div>
                        </div>

                        <div v-if="getLoaderState" role="status"
                            class="absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
                            <svg aria-hidden="true"
                                class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor" />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill" />
                            </svg>
                            <span class="sr-only">Loading...</span>
                        </div>
                    </form>

                    <!-- <div class="text-center-container">
                        <div class="line">
                            <button class="facebook-login-button" @click="facebookLogin">
                                <font-awesome-icon icon="facebook" style="color: #1977f2;" />
                                Facebook
                            </button>
                        </div> 
                        <p>{{ $t("oppure") }}</p>
                        <div class="line">
                            <button class="google-login-button" @click="googleLogin">
                                <img src="../assets/images/google-icon.png" style="height: 1.2rem;">
                                <p style="margin-left: 0.5rem;"> {{ $t("googleLogin") }}</p>
                            </button>
                        </div>
                    </div> -->
                </div>

                <div class="text-center mt-4">
                    <p style="user-select: none">{{ $t("Non sei registrato? Registrati") }}<a href="/register" class="ora">{{ $t("ora") }}</a>.</p>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
import axios from "axios";
import { useRouter } from 'vue-router';
import { ref, computed, onMounted } from 'vue'
import { authStore } from '../store/authorize'
import { loaderStore } from '@/store/loader'
import { googleSdkLoaded } from "vue3-google-login";

const store = authStore()
const loader = loaderStore();
const router = useRouter()
const email = ref('')
const password = ref('')
const getLoaderState = computed(() => loader.getLoaderState)
const wrongCredentials = ref('');
const showDownloadScreen = ref(false);

const redirectToAndroid = () => {
    window.location.href = "https://play.google.com/store/apps/details?id=com.micurobene.micurobenelite&hl=it";
};

const redirectToIOS = () => {
    window.location.href = "https://apps.apple.com/it/app/mi-curo-bene/id6468030195";
};

onMounted(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    // Show the download screen if the device is Android or iOS
    if (/android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)) {
        showDownloadScreen.value = true;
    }
});

const loginUser = async () => {
    loader.handleLoader(true);
    wrongCredentials.value = ''; // Resetta lo stato degli errori prima di ogni tentativo

    const userDetails = {
        email: email.value,
        password: password.value
    };

    try {
        const result = await store.authorizeUser(userDetails);

        if (!result) {
            // Se l'autenticazione fallisce
            wrongCredentials.value = 'login';
            loader.handleLoader(false);
            return;
        }

        await store.refreshState(store.getToken, store.getUser);

        // Timeout function
        const timeout = (ms) => new Promise(resolve => setTimeout(resolve, ms));

        // Loop per controllare se il menu è stato caricato
        for (let i = 0; i <= 5; i++) {
            if (localStorage.getItem('menu')) {
                router.push('/Registro/SchedaPaziente');
                loader.handleLoader(false);
                break;
            }
            await timeout(1000);
        }

    } catch (error) {
        wrongCredentials.value = 'login';
        loader.handleLoader(false);
    }
};


const facebookLogin = () => {}

const googleLogin = () => {
    googleSdkLoaded(google => {
        google.accounts.oauth2
            .initCodeClient({
                client_id:
                    process.env.VUE_APP_GOOGLE_CLIENT_ID,
                scope: process.env.VUE_APP_GOOGLE_SCOPE,
                redirect_uri: process.env.VUE_APP_GOOGLE_URL,
                callback: response => {

                    if (response.code) {

                        sendCodeToBackend(response.code);
                    }
                }
            })
            .requestCode();
    });
}

async function sendCodeToBackend(code) {
    try {
        console.log(code)
        loader.handleLoader(true)
        const response = await axios.post(
            "https://oauth2.googleapis.com/token",
            {
                code,
                client_id:
                    process.env.VUE_APP_GOOGLE_CLIENT_ID,
                client_secret: process.env.VUE_APP_GOOGLE_CLIENT_SECRET,
                redirect_uri: "postmessage",
                grant_type: "authorization_code"
            }
        );

        const accessToken = response.data.access_token;

        // Fetch user details using the access token
        const userResponse = await axios.get(
            "https://www.googleapis.com/oauth2/v3/userinfo",
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }
        );

        const userDetails = userResponse.data;

        await store.authorizeUserOAuth(userDetails)

        await store.refreshState(store.getToken, store.getUser)

        // Timeout function
        const timeout = (ms) => new Promise(resolve => setTimeout(resolve, ms));

        // Run some loop in async function
        (async () => {
            // Loop for 5 times
            for (let i = 0; i <= 5; i++) {
                // Do some stuff
                if (localStorage.getItem('menu')) {
                    router.push('/Registro/SchedaPaziente')
                    timeout(1000);
                    loader.handleLoader(false)
                break;
                }
                await timeout(1000);
            }
        })();
    } catch (error) {
        console.error("Token exchange failed:", error.response.data);
        loader.handleLoader(false)
        wrongCredentials.value = 'google';
    }
}
</script>


<style lang="scss" scoped>
.download-title {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
}

.platform-buttons {
    display: flex;
    flex-direction: column;  /* Arrange buttons in a column */
    align-items: center;
    gap: 0rem;
    margin-top: 1.5rem;
}

.platform-btn {
    color: white;
    background-color: #0F98D2;
    padding: 1.8rem 1.5rem;
    border-radius: 1.5rem;
    transition: all 0.2s ease;
    width: 100%;  /* Make buttons wider to improve appearance */
    max-width: 300px;  /* Optional max-width to control button size */
}

.platform-btn:hover {
    background-color: #58A552;
    color: white;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    border-radius: 4rem;
    box-shadow: 0.5rem 0.5rem 1rem #888888;
    font-size: 2.4rem;
    padding: 20px;
}

.form-group {
    padding: 10px;
    margin: 10px;
}

.container__title {
    color: #58A552;
    font-size: 5rem;
    font-weight: 800;
    margin-bottom: 1rem;

}

.google-signin-button {
    color: white;
    background-color: red;
    height: 50px;
    font-size: 16px;
    border-radius: 10px;
    padding: 10px 20px 25px 20px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.form {
    display: flex;
    width: 100%;
    flex-direction: column;
}

.text-left {
    text-align: left;
}

.or {
    display: flex;
    align-items: center;
    width: 100%;

    .hr {
        margin-right: 30px;
        margin-left: 30px;
        width: 100%;
        height: 10px;
        color: blue;
    }
}

.form__email,
.form__password {
    display: flex;
    flex-direction: column;

    label {
        text-align: left;
    }
}

.bottone-blu {
    margin-top: 20px;
    height: 40px;
    color: white !important;
    background-color: #0F98D2;
    border-radius: 1.4rem;
    padding-left: 2rem !important;
    padding-right: 2rem !important;
    transition: all .15s;
    border: 1px solid transparent;
    width: 45%;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 0.9rem;
    font-weight: 400;
    line-height: 1.6;
    color: #212529;
    background-color: #f8fafc;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.bottone-blu.scuro {
    background-color: #1977F2;
}

.bottone-bianco.scuro {
    color: grey !important;
    background-color: white;
    border: 1px solid grey;
}

.bottone-bianco {
    color: #0F98D2 !important;
    background-color: white;
    border-radius: 2.4rem;
    padding-left: 2rem !important;
    padding-right: 2rem !important;
    transition: all .15s;
    border: 1px solid #0F98D2;
}

.bottone-blu:hover {
    color: #0F98D2 !important;
    background-color: white;
    border: 1px solid #0F98D2;
}

.bottone-blu.scuro:hover {
    color: #1977F2 !important;
    background-color: white;
    border: 1px solid #1977F2;
}

.bottone-bianco.scuro:hover {
    background-color: grey;
}

.bottone-bianco:hover {
    color: white !important;
    background-color: #0F98D2;
    border: 1px solid transparent;
}

.register-alternate {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.services {
    display: flex;
    justify-content: space-around;
    margin-top: 5rem;
    margin-bottom: 5rem;
}

.serv-btn {
    padding: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.native,
.submit {
    margin-top: 3rem;
    margin-bottom: 3rem;
}

.bg-ombra-rounded {
    border-radius: 4rem;
    box-shadow: 0.5rem 0.5rem 1rem #888888;
}

.margine-grande-basso {
    margin-bottom: 20rem;
}

.text-center-container {
    text-align: center;
    margin-top: 5%;
    display: flex;
    align-items: center;
}

.text-center-container .line {
    flex: 1;
    border-top: 1px solid black;
    margin-left: 2%;
    margin-right: 2%;
}

.text-center-container p {
    color: black;
    margin: 0 0.75rem;
}

.facebook-login-button {
    margin-top: 10%;
    color: white !important;
    background-color: #1977F2;
    border-radius: 2.4rem;
    padding-left: 2rem !important;
    padding-right: 2rem !important;
    transition: all .15s;
    border: 1px solid transparent;

}

.facebook-login-button:hover {
    background-color: white;
    color: #1977F2 !important;
}

.google-login-button {
    //margin-left: 60%;
    //margin-top: 3%;
    color: grey !important;
    background-color: white;
    border-radius: 2.4rem;
    padding-left: 2rem !important;
    padding-right: 2rem !important;
    transition: all .15s;
    border: 1px solid grey;
    display: flex;
    align-items: center;
}

.google-login-button:hover {
    background-color: grey;
    color: white !important;
}

.password {
    padding: 10px;
    margin: 10px;
}

.password:hover {
    color: rgb(15, 72, 146);
}

.ora {
    font-style: italic;
    font-weight: bold;
    color: red;
}

.ora:hover {
    color: rgb(200, 0, 0);
}

@media all and (max-width: 980px) {
    .container_esh {
    margin: 0 auto;
    padding-top: 30px;
    width: 85%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 50%;
    }
}
</style>